import api from './api';

export async function getPortionStockByStand(mobileStandId) {
  const { data } = await api.get(`/mobile-stand-portion/mobile-stand/${mobileStandId}`);
  return data;
}

export async function getLowStockByStand(mobileStandId) {
  const { data } = await api.get(`/mobile-stand-portion/mobile-stand/${mobileStandId}/low-stock`);
  return data;
}

export async function createMobileStandPortion(payload) {
  const { data } = await api.post('/mobile-stand-portion', payload);
  return data;
}

export async function updateMobileStandPortion(id, payload) {
  const { data } = await api.put(`/mobile-stand-portion/${id}`, payload);
  return data;
}

export async function deleteMobileStandPortion(id) {
  const { data } = await api.delete(`/mobile-stand-portion/${id}`);
  return data;
}
